export const slugsToReplace = {
  'project-cases': 'case-studies',
  blueprint: 'company/insights',
  event: 'company/events',
};
export const pagesWithoutBreadcrumbs = [
  '/search',
  '/azure-crowdstrike-incident',
  '/person/',
  '/offer',
];
export const breadcrumbsCharacterLimit = 35;
